/**
 * OAuth/OIDC and ODP one-time-code return parameters that must not remain in the
 * address bar after exchange, failure, or logout — stale values break re-login UX.
 */
const AUTH_CALLBACK_QUERY_KEYS = [
  "code",
  "state",
  "session_state",
  "error",
  "error_description",
  "error_uri",
  "token",
  "expires_in",
];

export function stripAuthCallbackParamsFromSearchParams(searchParams) {
  for (const k of AUTH_CALLBACK_QUERY_KEYS) {
    searchParams.delete(k);
  }
}

/** Updates the current URL via history.replaceState, preserving other query params and hash. */
export function replaceLocationStrippingAuthCallbackParams() {
  if (typeof window === "undefined") return;
  try {
    const u = new URL(window.location.href);
    stripAuthCallbackParamsFromSearchParams(u.searchParams);
    const qs = u.searchParams.toString();
    const newUrl = u.pathname + (qs ? `?${qs}` : "") + (u.hash || "");
    window.history.replaceState(null, "", newUrl);
  } catch {
    // ignore
  }
}

/** Returns the same URL with auth callback params removed (for logout return_to, etc.). */
export function sanitizeUrlStrippingAuthCallbackParams(urlString) {
  const s = String(urlString || "").trim();
  if (!s) return s;
  try {
    const base = typeof window !== "undefined" ? window.location.origin : undefined;
    const u = new URL(s, base);
    stripAuthCallbackParamsFromSearchParams(u.searchParams);
    return u.toString();
  } catch {
    return s;
  }
}
